import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('DOMINIUM_token');
    const userData = localStorage.getItem('DOMINIUM_user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const login = async (telefono, password) => {
    const response = await api.post('/auth/login', { telefono, password });
    const { token, usuario } = response.data;
    localStorage.setItem('DOMINIUM_token', token);
    localStorage.setItem('DOMINIUM_user', JSON.stringify(usuario));
    setUser(usuario);
    return usuario;
  };

  const logout = () => {
    localStorage.removeItem('DOMINIUM_token');
    localStorage.removeItem('DOMINIUM_user');
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);